module.exports = __webpack_public_path__ + "static/media/usdc.a0b32a5f.svg";